import { connect, injectReducer, injectSaga, setSessionStorageItemJson } from '@vfde-fe/sails_core';
import { createStructuredSelector } from 'reselect';
import { initStore, setSalesChannel } from './action';
import reducer from './reducer';
import saga from './saga';
import { selectAppState, selectSalesChannel, selectSelectedOption } from './selector';
import mountFormSelection, { updateYoungSwitchState } from '../../components/formSelectionControl';
import mountImageHeader, { updateImageHeader } from '../../components/imageHeader';
import { SESSION_KEY, WRAPPER_ID_IMAGE_HEADER, WRAPPER_ID_TABS, WRAPPER_ID_YOUNG_SWITCH } from 'Constant';
import tariffSelection from '../TariffSelection';
import priceSection from '../PriceSection';
import productSelection from '../ProductSelection';
import { HtmlId, NameSpace } from './enum';
import loadState from '../../helper/stateHelper';
import { isFlexId } from '../../helper/additionalPageOptionsHelper';
import { mountLoadingSpinner } from '../../components/loadingSpinner';
import { areIdsNotEqual } from '../../helper/validator';
import { trackErrorNotification } from './helpers/tracking';
import mountTabs from '../../components/tabs';
import { mountAccordion } from '../../components/accordion';
import { setElementVisibility } from '../../helper/domHelper';
import { selectError } from './selector';
import { mountNotification } from '../../components/notification';
import { mountFootnotes } from '../../components/footnotes';

const mapStateToProps = createStructuredSelector({
    app: selectAppState,
    salesChannel: selectSalesChannel,
    selectedOption: selectSelectedOption,
    error: selectError,
});

const mapDispatch = {
    initStore,
    setSalesChannel,
};

type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

function gigacubePageContainer(_: State, actions: Actions) {
    mountLoadingSpinner();
    mountTabs(WRAPPER_ID_TABS);

    injectReducer(NameSpace.APP, reducer);
    injectSaga(NameSpace.APP, saga);

    tariffSelection();
    priceSection();
    productSelection();

    const persistedState = loadState();
    actions.initStore(persistedState);

    const imageHeaderComp = mountImageHeader(WRAPPER_ID_IMAGE_HEADER);
    const youngSwitchComp = mountFormSelection(actions.setSalesChannel, WRAPPER_ID_YOUNG_SWITCH);
    const errorNotificationComp = mountNotification(HtmlId.ERROR_NOTIFICATION);

    /** Mounts for tracking */
    mountAccordion();
    mountFootnotes();

    return {
        getDerivedStateFromProps ({ app, error, salesChannel, selectedOption }: State, oldState: State) {
            if (error) {
                setElementVisibility(HtmlId.GIGACUBE_CONTAINER, false);
                setElementVisibility(HtmlId.ERROR_CONTAINER, true);

                trackErrorNotification(error, errorNotificationComp);

                return;
            }

            const tariffId = selectedOption.subscriptionId;
            const didTariffChange = areIdsNotEqual(tariffId, oldState?.selectedOption?.subscriptionId);
            const didSalesChange = salesChannel !== oldState.salesChannel;
            const updateHeader = didTariffChange || didSalesChange;

            updateHeader && updateImageHeader(imageHeaderComp, salesChannel, isFlexId(tariffId));
            didSalesChange && updateYoungSwitchState(youngSwitchComp, salesChannel);

            setSessionStorageItemJson(SESSION_KEY, app);
        },
    };
}

const app = connect(mapStateToProps, mapDispatch)(gigacubePageContainer);

export default app;
